module.exports = "<!-- Generated by IcoMoon.io -->\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n<title>keyboard_arrow_up</title>\n<path d=\"M7.406 15.422l-1.406-1.406 6-6 6 6-1.406 1.406-4.594-4.594z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/keyboard_arrow_up.svg
// module id = 820
// module chunks = 0